export default __webpack_public_path__ + "static/ccc-e2e3d8673709827907871d677be2cf2a.jpeg";